/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { User } from '../models/User';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserService {
    /**
     * Check user token
     * Check user token
     * @returns any OK
     * @throws ApiError
     */
    public static checkUserToken(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/check_token',
            errors: {
                401: `access deined`,
            },
        });
    }
    /**
     * Users list
     * Print all existed users
     * @returns any successful operation
     * @throws ApiError
     */
    public static listUser(): CancelablePromise<{
        items?: Array<User>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/list',
        });
    }
    /**
     * Create user
     * This can only be done by the logged in user.
     * @param requestBody Created user object
     * @returns User successful operation
     * @throws ApiError
     */
    public static createUser(
        requestBody?: User,
    ): CancelablePromise<User> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Logs user into the system
     * @param username The user name for login
     * @param password The password for login in clear text
     * @returns any successful operation
     * @throws ApiError
     */
    public static loginUser(
        username?: string,
        password?: string,
    ): CancelablePromise<{
        token?: string;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/login',
            query: {
                'username': username,
                'password': password,
            },
            errors: {
                400: `Invalid username/password supplied`,
            },
        });
    }
    /**
     * Logs out current logged in user session
     * @returns any successful operation
     * @throws ApiError
     */
    public static logoutUser(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/logout',
        });
    }
    /**
     * Get user by user id
     * @param id The name that needs to be fetched. Use user1 for testing.
     * @returns User successful operation
     * @throws ApiError
     */
    public static getUserByName(
        id: number,
    ): CancelablePromise<User> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid username supplied`,
                404: `User not found`,
            },
        });
    }
    /**
     * Update user
     * This can only be done by the logged in user.
     * @param id The user id that need to be deleted
     * @param requestBody Update an existent user in the store
     * @returns any successful operation
     * @throws ApiError
     */
    public static updateUser(
        id: number,
        requestBody?: User,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/user/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete user
     * This can only be done by the logged in user.
     * @param id The user id that needs to be deleted
     * @returns void
     * @throws ApiError
     */
    public static deleteUser(
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/user/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid username supplied`,
                404: `User not found`,
            },
        });
    }
}
